/* eslint import/prefer-default-export: 0 */
import moment from 'moment';
import _ from 'lodash';

const DAY_HOURS = 24;
export const HOUR_FORMAT = 'HH:mm:ss';

const ZERO_DAYS_LABEL = 'on';
const BEFORE_LABEL = 'before';
const AFTER_LABEL = 'after';

const CURRENT_DATE = moment();

export const DAYS_ORDER = [
  { label: 'Monday', value: 'monday' },
  { label: 'Tuesday', value: 'tuesday' },
  { label: 'Wednesday', value: 'wednesday' },
  { label: 'Thursday', value: 'thursday' },
  { label: 'Friday', value: 'friday' },
  { label: 'Saturday', value: 'saturday' },
  { label: 'Sunday', value: 'sunday' },
];

export const isCurrentDate = momentDate => momentDate.isSame(CURRENT_DATE, 'd');

export const getHoursAsOptions = (format = 'hh:mm A') => {
  const options = [];
  _.forEach(_.times(DAY_HOURS, Number), hour => {
    const momentHour = moment(hour, 'HH');
    options.push({
      label: momentHour.format(format),
      value: momentHour.format(HOUR_FORMAT),
    });
  });

  return options;
};

export const getDaysAsOptions = (
  isBefore = false,
  maxDays = 14,
  text = 'day',
  shouldUseSuffix = true,
  shouldUseZero = true,
) => {
  const options = [];
  _.forEach(_.times(maxDays + 1, Number), day => {
    const isZero = _.isEqual(day, 0);
    if (!shouldUseZero && isZero) {
      return;
    }
    const dayValue = day;
    const suffix = isBefore ? BEFORE_LABEL : AFTER_LABEL;
    const label = isZero
      ? ZERO_DAYS_LABEL
      : `${dayValue} ${text}${dayValue === 1 ? '' : 's'}${shouldUseSuffix ? ` ${suffix}` : ''}`;

    options.push({
      label,
      value: dayValue,
    });
  });

  return options;
};

export const isSameDay = (firstDate, secondDate) => {
  const date1 = moment(firstDate);
  const date2 = moment(secondDate);
  return date1.isSame(date2, 'year') && date1.isSame(date2, 'month') && date1.isSame(date2, 'day');
};

export const DIFF_TIME_FORMAT = 'MMMM D, YYYY [at] h:mm A';
